import { ActivityType } from "@hulanbv/platformapp";

const activityTypeLabels: Record<ActivityType, string> = {
  [ActivityType.VALUE_IDENTIFICATION]: "Values Card Sort",
  [ActivityType.VALUE_OBSTACLES]: "Value Obstacles",
  [ActivityType.LIVE_YOUR_VALUES]: "Take some steps toward your values",
  [ActivityType.TWO_SIDES_OF_THE_SAME_COIN]:
    "Values and Barriers are 2 Sides of the Same Coin",
  [ActivityType.THOUGHTS_ON_CARDS]: "Thoughts on Cards",
};

export { activityTypeLabels };
